import React, { useEffect, useState, useMemo } from "react";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import {
  ROUTE_PATHS,
  SCHEDULES_DATA_KEY,
} from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";

const useOutOfPocketMaxSchedule = (
  onSelect,
  hideModal,
  initialSelectParams,
  intialSelectMode,
  initialLookupType,
  selectModeParamData,
  onNavigate
) => {
  const [data, setData] = useState([]); /* Out Of Pocket Max Schedule Data */
  // const [paramsData, setParamsData] = useState({
  //   opcScheduleName: "",
  //   hiddenRecordIndicator: "Active",
  // });
  const { axios_helper_no_header } = useAxios();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const parmKey = "opcScheduleName";
  const statusKey = "opcDispOutdatedRcds";
  const {
    ADD_OUT_OF_POCKET_MAX_SCHEDULE,
    EDIT_OUT_OF_POCKET_MAX_SCHEDULE,
    DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE,
    COPY_OUT_OF_POCKET_MAX_SCHEDULE,
    OUT_OF_POCKET_MAX_SCHEDULE_NOTE,
    OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
  } = ROUTE_PATHS;
  const screen_title = "Out Of Pocket Max Schedule";
  // const screenNumber = "RCOPC001";
  /* Search form fields that needs to be shown for filtering */

  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    selectedCodesListItem = "",
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      opcScheduleName: "",
      hiddenRecordIndicator: "Active",
    },
  } = currentState;

  const [selectMode, setSelectedMode] = useState(intialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [disabledDropdowns, setDisabledDropdowns] = useState({});

  const screenNumber = selectMode ? "RCOPC005" : "RCOPC001";
  const initialParams = selectMode
    ? { ...selectModeParamData, hiddenRecordIndicator: "Active" }
    : initialParamsData;

  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(initialParams);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.opcScheduleName;
  const updatedParamsData = {
    ...paramsData,
    opcScheduleName: lastScheduleName,
  };

  const formFields = selectMode
    ? [
        {
          fieldLabel: "OPC Schedule Name",
          name: "opcScheduleName",
          label: "Schedule",
          type: "text",
          value: "",
          maxLength: 10,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          value: "",
          maxLength: 1,
        },
      ]
    : [
        {
          fieldLabel: "OPC Schedule Name",
          name: "opcScheduleName",
          label: "Schedule",
          type: "text",
          value: "",
          maxLength: 10,
        },
        {
          fieldLabel: "Hidden Record IndicatorValid Values",
          name: "hiddenRecordIndicator",
          label: "Status",
          type: "dropdown",
          value: "",
          maxLength: 1,
        },
      ];
  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { fieldLabel: "Hidden Record Indicator", condition: "Valid Values" },
  ];
  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.fieldLabel + item.condition),
  };
  /* ACTION BUTTONS info that needs to be displayed on the page */

  const handleBack = () => {
    if (lookupType === "external" && selectMode) {
      window.parent.postMessage(
        {
          type: "hideModal",
        },
        "*"
      );
    } else {
      hideModal();
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Out Of Pocket Max Schedule",
          button_handeler: () => {
            navigateToPage(ADD_OUT_OF_POCKET_MAX_SCHEDULE, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = useMemo(() => {
    return selectMode
      ? [
          {
            label: "Select",
            icon: <span className="material-icons">add</span>,
            command: () => {
              const paramDataMap = new Map();
              selectParams.forEach((key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                  paramDataMap.set(key["source"], rowData[key["target"]]);
                }
              });
              const paramData = Object.fromEntries(paramDataMap);
              if (lookupType !== "external") {
                onSelect(paramData);
              } else {
                window.parent.postMessage(
                  { type: "responseData", data: paramData },
                  "*"
                );
              }
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              /* const message = {
                message: "navigate-to-presto",
                programCode: "RCOPC002I",
                parameters: {
                  opcScheduleName: rowData["opcScheduleName"],
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");
              */
              if (lookupType !== "external") {
                onNavigate({
                  navType: "local",
                  data: rowData,
                  target: ROUTE_PATHS.DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE,
                  schedulesDataKey: "selectedSchedules",
                });
              } else {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "OUT_OF_POCKET_MAX_SCHEDULE_READ_ONLY",
                  schedulesDataKey: "selectedSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              }
            },
          },
          {
            label: "Steps",
            icon: <span className="material-icons">list</span>,
            command: () => {
              /* const message = {
                message: "navigate-to-presto",
                programCode: "RCOPD001I",
                parameters: {
                  opcScheduleName: rowData["opcScheduleName"],
                  opcBasis: rowData["opcBasis"],
                  opcDescription: rowData["opcDescription"],
                  opcStepCount: rowData["opcStepCount"],
                  wrkDescription25: "",
                },
              };
              console.log(message, "message");
              window.top.postMessage(message, "*");
              */
              if (lookupType !== "external") {
                onNavigate({
                  navType: "local",
                  data: rowData,
                  target: ROUTE_PATHS.OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
                  schedulesDataKey: "selectedSchedules",
                  additionalData: {
                    paramsData: {},
                  },
                });
              } else {
                const message = {
                  type: "navigateData",
                  data: { ...rowData },
                  target: "OUT_OF_POCKET_STEPS",
                  schedulesDataKey: "selectedSchedules",
                };
                console.log("display message", message);
                window.parent?.postMessage(message, "*");
              }
            },
          },
        ]
      : [
          {
            label: "Note",
            icon: <span className="material-icons">note</span>,
            command: () => {
              navigateToPage(OUT_OF_POCKET_MAX_SCHEDULE_NOTE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Edit",
            icon: <span className="material-icons">edit</span>,
            command: () => {
              navigateToPage(EDIT_OUT_OF_POCKET_MAX_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Copy",
            icon: <span className="material-icons">content_copy</span>,
            command: () => {
              navigateToPage(COPY_OUT_OF_POCKET_MAX_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Delete",
            icon: <span className="material-icons">delete</span>,
            command: () => {
              openConfirmationModal();
            },
          },
          {
            label: "Display",
            icon: <span className="material-icons">visibility</span>,
            command: () => {
              navigateToPage(DISPLAY_OUT_OF_POCKET_MAX_SCHEDULE, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: "Steps",
            icon: <span className="material-icons">list</span>,
            command: () => {
              navigateToPage(OUT_OF_POCKET_MAX_SCHEDULE_STEPS, [
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
                {
                  selectedSchedules: selectedRows.length
                    ? selectedRows
                    : [rowData],
                  previousScreen: location.pathname,
                  currentIndex: 0,
                },
              ]);
            },
          },
          {
            label: rowData[statusKey] === "Hidden" ? "Unhide" : "Hide",
            icon: <span className="material-icons">visibility_off</span>,
            command: () => {
              openHideConfirmationModal();
            },
          },
        ];
  }, [rowData, selectedRows]);
  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "opcScheduleName",
    },
    {
      header: "Description",
      field: "opcDescription",
    },
    {
      header: "Basis",
      field: "opcBasis",
      style: { width: "5%" },
    },
    {
      header: "Steps",
      field: "opcStepCount",
      style: { width: "5%" },
    },
    {
      header: "Indicators",
      field: "noteExistenceStatus",
      body: (rowData) => (
        <IndicatorCell
          rowData={rowData}
          fields={[
            "noteExistenceStatus",
            "oopSubstepExistenceSts"
          ]}
          tooltipContent={{
            noteExistenceStatus: "Notes",
            oopSubstepExistenceSts: "Substep"
          }}
        />
      ),
    },
    /* {
      field: "oopSubstepExistenceSts",
      body: (rowData) => (
        <span className={rowData.oopSubstepExistenceSts ? "highlight" : ""}>
          {rowData.oopSubstepExistenceSts}
        </span>
      ),
    },*/
    {
      header: "Status",
      field: "opcDispOutdatedRcds",
    },
  ];
  /* Param Key which used as bridge between various operations on tabluar data */

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/opcOutPoktMaxSchCtrl`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };
  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };
  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, lookupType]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };
  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };
  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const hidePocketSchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        opcScheduleName: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/opcOutPoktMaxSchCtrl/hideUnhide",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error updating the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };
  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { opcScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/opcOutPoktMaxSchCtrl", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData, screenNumber: screenNumber };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/opcOutPoktMaxSchCtrl/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "initData") {
        const externalData = data?.data || {};
        setSelectedMode(data?.selectMode);
        setLookupType("external");
        setParamsData({ ...paramsData, ...externalData?.paramsData });
        setSelectParams(externalData?.params);
        setDisabledDropdowns({ hiddenRecordIndicator: true });
      }
    };
    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    selectMode,
    statusKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    isHideConfirmationModalOpen,
    closeConfirmationModal,
    closeHideConfirmationModal,
    hidePocketSchedule,
    deletePriceSchedule,
    setSelectedOption,
    setHideSelectedOption,
    disabledDropdowns,
  };
};
export default useOutOfPocketMaxSchedule;
